export default "__VITE_ASSET__eibURL_6__"